<base-dialog [title]="data.title">
   <strong class="text bold">{{ data.subTitle }}</strong>
   <p class="text">{{ data.description }}</p>

   <button class="button" (click)="dialogRef.close(true)">{{ data.btnText }}</button>
</base-dialog>
